// extracted by mini-css-extract-plugin
export default {"root":"Spinner-module-root","bounce":"Spinner-module-bounce","shadow":"Spinner-module-shadow"};